/**
 * zoho-forms.js v3
 * Doble envío Shopify + Zoho CRM Web-to-Lead
 * Incluye el script de analytics de Zoho para pasar la validación CAPTCHA
 */
(function () {
  'use strict';

  var ZOHO = {
    action:     'https://crm.zoho.com/crm/WebToLeadForm',
    xnQsjsdp:  'a7701a73a23d6e0b7cba1fd8b5fe91f41cf4aa47d64f794b0cce852e1566621f',
    xmIwtLD:   '0b85f9916564dd6e8605e68cd73ce31afda037a531864cd0fd2925c86d9a0362f93d3689596084a68bfe26bc3d8cb66e',
    actionType: 'TGVhZHM=',
    returnURL:  window.location.origin,
    /* Script de analytics de Zoho — establece la sesión/token que valida el CAPTCHA */
    analyticsScript: 'https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=64632dee88edb7123f25ef66114356362a3f0035efa8215f911d2e5bceadbd2ad2fcc11a76a20dcaeba6965b525c8d8fgid9000857ccd723f31d1db893275aa8ad29c21d214a23290b4b9c3b266399fa7afgidee5bee9c1e91b6d5b53687174ae240a45c7fb47a1554bca8bb125ef4878c777bgid46307b8623908875c48b69664a871ecdd729540a40d47cf5932258370a2177c7&tw=43d1b9b80da3172832328cf992289a4c8fe866e11af2bc05f37dd60d6b5f9aad&version=v2'
  };

  /* Carga el script de tracking de Zoho al iniciar la página */
  function loadZohoAnalytics() {
    if (document.getElementById('wf_anal')) return;
    var s = document.createElement('script');
    s.id  = 'wf_anal';
    s.src = ZOHO.analyticsScript;
    s.async = true;
    document.head.appendChild(s);
  }

  function sendToZoho(fields) {
    var iframeName = 'zoho_iframe_' + Date.now();
    var iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    var form = document.createElement('form');
    form.method = 'POST';
    form.action = ZOHO.action;
    form.target = iframeName;
    form.style.display = 'none';
    form.setAttribute('accept-charset', 'UTF-8');

    var allFields = Object.assign({
      xnQsjsdp:      ZOHO.xnQsjsdp,
      xmIwtLD:       ZOHO.xmIwtLD,
      actionType:    ZOHO.actionType,
      returnURL:     ZOHO.returnURL,
      zc_gad:        '',
      aG9uZXlwb3Q:  ''   /* honeypot — debe ir vacío */
    }, fields);

    Object.keys(allFields).forEach(function (key) {
      var input = document.createElement('input');
      input.type  = 'hidden';
      input.name  = key;
      input.value = allFields[key] != null ? String(allFields[key]) : '';
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();

    setTimeout(function () {
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      if (form.parentNode)   form.parentNode.removeChild(form);
    }, 10000);
  }

  function val(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function hookForm(formId, buildFields) {
    var form = document.getElementById(formId);
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      sendToZoho(buildFields(form));
      setTimeout(function () {
        HTMLFormElement.prototype.submit.call(form);
      }, 1500);
    });
  }

  /* ── Landing form ── */
  hookForm('LandingForm', function (form) {
    return {
      'Last Name':   val(form, 'contact[name]') || 'Sin nombre',
      'First Name':  '',
      'Email':       val(form, 'contact[email]'),
      'Phone':       val(form, 'contact[phone]'),
      'LEADCF1':     val(form, 'contact[project_type]') || '-None-',
      'Description': val(form, 'contact[body]'),
      'Lead Source': 'Página web',
      'Lead Status': 'Por contactar',
      'LEADCF39':    'NO (SIN TE)'
    };
  });

  /* ── Contacto general ── */
  hookForm('ContactForm', function (form) {
    var asunto  = val(form, 'contact[subject]');
    var mensaje = val(form, 'contact[body]');
    return {
      'Last Name':   val(form, 'contact[name]') || 'Sin nombre',
      'First Name':  '',
      'Email':       val(form, 'contact[email]'),
      'Phone':       val(form, 'contact[phone]'),
      'Description': asunto ? ('Asunto: ' + asunto + '\n\n' + mensaje) : mensaje,
      'Lead Source': 'Página web',
      'Lead Status': 'Por contactar',
      'LEADCF39':    'NO (SIN TE)'
    };
  });

  /* ── Cotización ── */
  hookForm('CotizacionForm', function (form) {
    var equipoMap = {
      'contact[equipo_cardio]':     'Ciclismo Indoor',
      'contact[equipo_fuerza]':     'Fuerza',
      'contact[equipo_funcional]':  'HIIT',
      'contact[equipo_maquinas]':   'Multigym',
      'contact[equipo_piso]':       'Accesorios',
      'contact[equipo_accesorios]': 'Accesorios'
    };
    var intereses = Object.keys(equipoMap).reduce(function (acc, key) {
      var el = form.querySelector('[name="' + key + '"]');
      if (el && el.checked) acc.push(equipoMap[key]);
      return acc;
    }, []);

    var presupuesto = val(form, 'contact[presupuesto]');
    var mensaje     = val(form, 'contact[body]');
    var desc = [presupuesto ? 'Presupuesto: ' + presupuesto : '', mensaje].filter(Boolean).join('\n\n');

    return {
      'Last Name':   val(form, 'contact[name]') || 'Sin nombre',
      'First Name':  '',
      'Email':       val(form, 'contact[email]'),
      'Phone':       val(form, 'contact[phone]'),
      'Company':     val(form, 'contact[empresa]'),
      'LEADCF1':     val(form, 'contact[tipo_proyecto]') || '-None-',
      'LEADCF38':    intereses.join(';'),
      'Description': desc,
      'Lead Source': 'Página web',
      'Lead Status': 'Por contactar',
      'LEADCF39':    'NO (SIN TE)'
    };
  });

  /* ── Init ── */
  loadZohoAnalytics();

})();
